import React from "react";
import { Button, Col, Form, Input, message, Row, Spin } from "antd";
import { useAuthContext } from "../../context/AuthContext";
import { Link, useNavigate } from 'react-router-dom';
import { useState } from "react";
import ListAddress from "../../components/ListAddress/ListAddress";
import ListOrders from "../../components/ListOrders/ListOrders";
import { removeToken } from "../../helpers";

const Profile = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const { user, isLoading, setUser } = useAuthContext();

  const handleProfileUpdate = async (data) => {
    setLoading(true);
    try {
      /*const response = await fetch(`${API}/users/${user.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          // set the auth token to the user's jwt
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();

      setUser(responseData);*/
      message.success("Data saved successfully!");
    } catch (error) {
      console.error(Error);
      message.error("Error While Updating the Profile!");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    removeToken();
    setUser({});
    navigate("/", { replace: true });
  }

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <div className="container py-5">
      <div className="row text-end">
        <h4>Welcome {user?.full_name}, </h4><Link className="text-decoration-none text-dark" onClick={() => handleLogout()}><i className="fa fa-sign-out-alt"></i> LogOut</Link>
      </div>
      <div className="row">
        <h4>Your Orders</h4>
        <ListOrders></ListOrders>
        <h4>Your Addresses&nbsp;
          <Link className ="link" to="/user-addresses/create">
            <i className="fa fa-plus-circle" />
          </Link>
        </h4>
        <ListAddress></ListAddress>
      </div>
      <Form
        layout="vertical" style={{display: 'none'}}
        initialValues={{
          username: user?.full_name,
          email: user?.email
        }}
        onFinish={handleProfileUpdate}
      >
        <Row gutter={[16, 16]}>
          <Col md={8} lg={8} sm={24} xs={24}>
            <Form.Item
              label="Username"
              name="username"
              rules={[
                {
                  required: true,
                  message: "Name is required!",
                  type: "string",
                },
              ]}
            >
              <Input placeholder="Full Name" />
            </Form.Item>
          </Col>
          <Col md={8} lg={8} sm={24} xs={24}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Email is required!",
                  type: "email",
                },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>
          </Col>
        </Row>
        <Button
          className="profile_save_btn"
          htmlType="submit"
          disabled={false}
          type="primary"
          size="large"
        >
          {loading ? (
            <>
              <Spin size="small" /> Saving
            </>
          ) : (
            "Save"
          )}
        </Button>
      </Form>
    </div>
  );
};

export default Profile;